import React from "react"

import {
  ListEmptyState,
  listEmptyVariant
} from "../../../components/Table/ListEmptyState.tsx"
import { type ProjectFilters } from "../redux/projects.types.ts"

// Not filters a user narrowed the list with: paging, sort, search (reported on
// its own) and the Active/Archive tab, which every request carries.
const NOT_A_FILTER = new Set<keyof ProjectFilters>([
  "page",
  "page_size",
  "q",
  "ordering",
  "view"
])

export function countProjectFilters(filters?: Partial<ProjectFilters> | null) {
  if (!filters) return 0
  return Object.entries(filters).filter(([key, value]) => {
    if (NOT_A_FILTER.has(key as keyof ProjectFilters)) return false
    if (Array.isArray(value)) return value.length > 0
    return value !== null && value !== undefined && value !== ""
  }).length
}

interface ProjectsEmptyProps {
  hasSearch?: boolean
  filters?: Partial<ProjectFilters> | null
  /** Narrowing held outside the filters (a quick view, My projects). */
  narrowingViews?: number
  loadFailed?: boolean
  onRetry?: () => void
  onClearFilters?: () => void
}

export function ProjectsEmpty({
  hasSearch,
  filters,
  narrowingViews = 0,
  loadFailed,
  onRetry,
  onClearFilters
}: ProjectsEmptyProps) {
  const variant = listEmptyVariant({
    loadFailed,
    hasSearch,
    activeFilterCount: countProjectFilters(filters) + narrowingViews
  })

  return (
    <ListEmptyState
      object="projects"
      variant={variant}
      onRetry={onRetry}
      onClearFilters={onClearFilters}
    />
  )
}
